import Photo from "./Photo";

export default Photo;
export * from "./PhotoRedux";
